export default class MandateModel {
    _id!: string;
    accountType!: string;
    bseStatus!: string;
    mandateType!: string;
    received!: boolean;
    forwarded!: boolean;
    userId!: string;
    accountNumber!: string;
    IFSC!: string;
    mandateAmount!: string;
    bseMandateId!: string;
    upiId?: string;
    createdAt!: string;
    // isAutoGenerated = true, mandate created by internal team of AssetPlus.
    // isAutoGenerated = false, mandate is auto generated by the system.
    isAutoGenerated: boolean = true;

    // For mandate approval process
    icon?: string;
    bankName?: string;
    email?: string;

    getString() {
        if (this.bseMandateId && this.bseMandateId.length > 0) {
            return "#" + this.bseMandateId.substring(this.bseMandateId.length - 6) + " - (Limit: " + this.mandateAmount + ")";
        }
        return "#PENDING";
    }

    isISIPMandate() {
        return this.mandateType == "I";
    }

    isXSIPMandate() {
        return this.mandateType == "X";
    }

    isApproved() {
        return this.bseStatus === "APPROVED";
    }

    getStatus() {
        return this.isApproved() ? "Approved" : "Pending approval";
    }

    isUnuploaded() {
        return this.isXSIPMandate() && !this.received! && !this.isApproved();
    }

    getMandateType(): 'Offline' | 'Online' | 'UpiMandate' {
        switch (this.mandateType) {
            case "U": return "UpiMandate"
            case "X": return "Offline"
            default:
                return "Online"
        }
    }

    getBankType(): string {
        return MandateModel.BankTypes.find(e => e.code == this.accountType)!.label
    }

    static getBankTypeFromCode(value: string) {
        return MandateModel.BankTypes.find(e => e.code == value)?.label
    }

    static BankTypes = [
        { code: "SB", label: "Savings Account" },
        { code: "CB", label: "Current Account" },
        { code: "NE", label: "NRE Account" },
        { code: "NO", label: "NRO Account" }
    ];

    getBankIcon() {
        return MandateModel.bankIcons.find(e => e === this.icon?.toLowerCase()) ?? "default_bank";
    }

    getBankName() {
        return this.bankName ?? this.IFSC.substring(0, 4);
    }

    static getUpiAppName(upiId: string | undefined, bankName: string) {
        if (upiId && upiId.includes("@")) {
            upiId = upiId.toLocaleLowerCase();
            const splitUpi = upiId.split("@");
            if (splitUpi.length == 2) {
                const psp = splitUpi[1];
                if (/^ok/.test(psp)) {
                    return `Google Pay (${bankName})`
                }
                else if (/^pt/.test(psp)) {
                    return `Paytm (${bankName})`;
                }
                else if (/^(phonepe|ibl|axl|ybl|bob|hdfc|sbi|pnb|kotak)$/.test(psp)) {
                    return `PhonePe (${bankName})`
                }
                // return MandateModel.upiPaymentApp.find(item => psp.startsWith(item.upiPrefix))?.paymentApp ?? "payment app";
            }
        }
        return "payment app";
    }

    static upiPaymentApp = [
        { "upiPrefix": "okaxis", "paymentApp": "Google Pay (linked with Axis Bank)" },
        { "upiPrefix": "okhdfcbank", "paymentApp": "Google Pay (HDFC Bank)" },
        { "upiPrefix": "okicici", "paymentApp": "Google Pay (ICICI Bank)" },
        { "upiPrefix": "oksbi", "paymentApp": "Google Pay (SBI)" },

        // { "upiPrefix": "okaxis", "paymentApp": "Flipkart UPI (Axis Bank)" },
        // { "upiPrefix": "abcdicici", "paymentApp": "Aditya Birla Capital Digital (ICICI Bank)" },
        // { "upiPrefix": "apl", "paymentApp": "Amazon Pay (Axis Bank)" },
        // { "upiPrefix": "yapl", "paymentApp": "Amazon Pay (Yes Bank)" },
        // { "upiPrefix": "rapl", "paymentApp": "Amazon Pay (RBL Bank)" },
        // { "upiPrefix": "abfspay", "paymentApp": "Bajaj Finserv (Axis Bank)" },
        // { "upiPrefix": "bpunity", "paymentApp": "BharatPe (Unity Small Finance Bank)" },
        // { "upiPrefix": "axisb", "paymentApp": "CRED (Axis Bank)" },
        // { "upiPrefix": "yescred", "paymentApp": "CRED (Yes Bank)" },
        // { "upiPrefix": "yescurie", "paymentApp": "Curie Money (Yes Bank)" },
        // { "upiPrefix": "yesfam", "paymentApp": "FamApp by Trio (Yes Bank)" },
        // { "upiPrefix": "fifederal", "paymentApp": "Fi Money (Federal Bank)" },
        // { "upiPrefix": "fkaxis", "paymentApp": "Flipkart UPI (Axis Bank)" },
        // { "upiPrefix": "freoicici", "paymentApp": "Freo (ICICI Bank)" },
        // { "upiPrefix": "gwaxis", "paymentApp": "Genwise (Axis Bank)" },
        // { "upiPrefix": "inhdfc", "paymentApp": "IND Money (HDFC Bank)" },
        // { "upiPrefix": "jupiteraxis", "paymentApp": "Jupiter Money (Axis Bank)" },
        // { "upiPrefix": "goaxb", "paymentApp": "Kiwi (Axis Bank)" },
        // { "upiPrefix": "kphdfc", "paymentApp": "Kredit.Pe (HDFC Bank)" },
        // { "upiPrefix": "ikwik", "paymentApp": "MobiKwik (HDFC Bank)" },
        // { "upiPrefix": "mvhdfc", "paymentApp": "Money View (HDFC Bank)" },
        // { "upiPrefix": "naviaxis", "paymentApp": "Navi (Axis Bank)" },
        // { "upiPrefix": "niyoicici", "paymentApp": "Niyo Global (ICICI Bank)" },
        // { "upiPrefix": "oneyes", "paymentApp": "One Card (Yes Bank)" },

        { "upiPrefix": "ptyes", "paymentApp": "Paytm (Yes Bank)" },
        { "upiPrefix": "ptaxis", "paymentApp": "Paytm (Axis Bank)" },
        { "upiPrefix": "pthdfc", "paymentApp": "Paytm (HDFC Bank)" },
        { "upiPrefix": "ptsbi", "paymentApp": "Paytm (SBI)" },


        { "upiPrefix": "phonepe", "paymentApp": "PhonePe (Yes Bank)" },
        { "upiPrefix": "ibl", "paymentApp": "PhonePe (ICICI Bank)" },
        { "upiPrefix": "axl", "paymentApp": "PhonePe (Axis Bank)" },
        { "upiPrefix": "ybl", "paymentApp": "PhonePe (Yes Bank)" },
        { "upiPrefix": "bob", "paymentApp": "PhonePe (Bank of Baroda Bank)" },
        { "upiPrefix": "hdfc", "paymentApp": "PhonePe (HDFC Bank)" },
        { "upiPrefix": "sbi", "paymentApp": "PhonePe (State Bank of India)" },
        { "upiPrefix": "pnb", "paymentApp": "PhonePe (Punjab National Bank)" },
        { "upiPrefix": "kotak", "paymentApp": "PhonePe (Kotak Mahindra Bank)" },

        // { "upiPrefix": "yespop", "paymentApp": "POPclub (Yes Bank)" },
        // { "upiPrefix": "rmrbl", "paymentApp": "Rio Money (RBL Bank)" },
        // { "upiPrefix": "pingpay", "paymentApp": "Samsung Pay (Axis Bank)" },
        // { "upiPrefix": "timecosmos", "paymentApp": "TimePay (The Cosmos Co-Operative Bank Ltd.)" },
        // { "upiPrefix": "twidpay", "paymentApp": "Twid Pay (Yes Bank)" },
        // { "upiPrefix": "waicici", "paymentApp": "WhatsApp Pay (ICICI Bank)" },
        // { "upiPrefix": "waaxis", "paymentApp": "WhatsApp Pay (Axis Bank)" },
        // { "upiPrefix": "wahdfcbank", "paymentApp": "WhatsApp Pay (HDFC Bank)" },
        // { "upiPrefix": "wasbi", "paymentApp": "WhatsApp Pay (SBI)" },
        // { "upiPrefix": "yestp", "paymentApp": "Twid Pay (Yes Bank)" },
        // { "upiPrefix": "tapicici", "paymentApp": "Tata Neu (ICICI Bank)" },
        // { "upiPrefix": "shriramhdfcbank", "paymentApp": "Shriram One (HDFC Bank)" },
        // { "upiPrefix": "sliceaxis", "paymentApp": "slice (Axis Bank)" },
        // { "upiPrefix": "superyes", "paymentApp": "super.money (Yes Bank)" },
        // { "upiPrefix": "seyes", "paymentApp": "salaryse (Yes Bank)" },
        // { "upiPrefix": "yestp", "paymentApp": "Twid Pay (Yes Bank)" },
        // { "upiPrefix": "yestp", "paymentApp": "Twid Pay (Yes Bank)" }
    ]

    static bankIcons = ["barb", "bdbl", "bkid", "cbin", "ciub", "cnrb", "csbk", "dcbl", "dlxb", "fdrl", "hdfc", "ibkl", "icic", "idfb", "idib", "indb", "ioba", "jaka", "karb", "kkbk", "kvbl", "mahb", "psib", "punb", "ratn", "sbin", "sibl", "tmbl", "ubin", "ucba", "utib", "yesb"]
}